// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (max-width: 1728px) {
    .scl--web-page-company-hero-section .scl--web-component-hero-content {
        padding-left: var(--global-laptop-padding-left);
        padding-right: 0;
    }

    .scl--web-page-company-hero-section .scl--web-page-company-gradient-overlay .scl--conic-com-spotlight{
        width: 38%;
    }

    .scl--wpchs-con-st{
        width: 60%;
    }

    .scl--web-page-company-our-value-section .scl--stv-con-bo-str {
        height: auto;
    }

    .scl--web-page-company-our-value-section .scl--scbs-sec-ti-con-bo-str{
        gap: 20px;
    }

    .scl--web-page-company-our-principle-section{
        min-height: 1156px;
    }

    .scl--wpcovs-se-con-str .scl--stv-con-bo-str{
        padding-left: var(--global-laptop-padding-left);
        padding-right: var(--global-laptop-padding-right);
    }

    .scl--wpcovs-se-con-str{
        padding-bottom: 100px;
    }

    .scl--wpcops-bo-cont-str-compl{
        padding-left: var(--global-laptop-padding-left);
        padding-right: var(--global-laptop-padding-right);
    }

    .scl--wpds-resp-con-stl{
        padding-left: var(--global-laptop-padding-left);
        padding-right: var(--global-laptop-padding-right);
    }

    .scl--web-page-differ-section{
        min-height: 1000px;
    }

    .scl--wdacs-st-cont-bo-st{
        grid-template-columns: repeat(3, minmax(150px, 1fr));
    }

    .scl--wpchs-tal-con-str{
        min-height: 897px;
    }

    .scl--wtcs-ti-con-st{
        padding-left: var(--global-laptop-padding-left);
        padding-right: var(--global-laptop-padding-right);
    }

    .scl--wpchs-tal-con-str .scl--stv-con-bo-str{
        height: auto;
    }

    .scl--wpchs-tal-con-str .scl--scbs-sec-ti-con-bo-str{
        gap: 20px;
    }

    .scl--wtcs-nea-fo-lin-dcl-st{
        gap: 180px;
    }

    .scl--web-page-ctac-section{
        min-height: 1393px;
    }

    .scl--wpcs-cont-stl-bo{
        padding-left: var(--global-laptop-padding-left);
        padding-right: var(--global-laptop-padding-right);
    }

    .scl--wpctas-st-cont-bo-st{
        grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
        gap: 27px;
    }

    
}`, "",{"version":3,"sources":["webpack://./src/page-module/page-services/company/css/companySl.css"],"names":[],"mappings":"AAAA;IACI;QACI,+CAA+C;QAC/C,gBAAgB;IACpB;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,+CAA+C;QAC/C,iDAAiD;IACrD;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,+CAA+C;QAC/C,iDAAiD;IACrD;;IAEA;QACI,+CAA+C;QAC/C,iDAAiD;IACrD;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,oDAAoD;IACxD;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,+CAA+C;QAC/C,iDAAiD;IACrD;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,+CAA+C;QAC/C,iDAAiD;IACrD;;IAEA;QACI,2DAA2D;QAC3D,SAAS;IACb;;;AAGJ","sourcesContent":["@media (max-width: 1728px) {\n    .scl--web-page-company-hero-section .scl--web-component-hero-content {\n        padding-left: var(--global-laptop-padding-left);\n        padding-right: 0;\n    }\n\n    .scl--web-page-company-hero-section .scl--web-page-company-gradient-overlay .scl--conic-com-spotlight{\n        width: 38%;\n    }\n\n    .scl--wpchs-con-st{\n        width: 60%;\n    }\n\n    .scl--web-page-company-our-value-section .scl--stv-con-bo-str {\n        height: auto;\n    }\n\n    .scl--web-page-company-our-value-section .scl--scbs-sec-ti-con-bo-str{\n        gap: 20px;\n    }\n\n    .scl--web-page-company-our-principle-section{\n        min-height: 1156px;\n    }\n\n    .scl--wpcovs-se-con-str .scl--stv-con-bo-str{\n        padding-left: var(--global-laptop-padding-left);\n        padding-right: var(--global-laptop-padding-right);\n    }\n\n    .scl--wpcovs-se-con-str{\n        padding-bottom: 100px;\n    }\n\n    .scl--wpcops-bo-cont-str-compl{\n        padding-left: var(--global-laptop-padding-left);\n        padding-right: var(--global-laptop-padding-right);\n    }\n\n    .scl--wpds-resp-con-stl{\n        padding-left: var(--global-laptop-padding-left);\n        padding-right: var(--global-laptop-padding-right);\n    }\n\n    .scl--web-page-differ-section{\n        min-height: 1000px;\n    }\n\n    .scl--wdacs-st-cont-bo-st{\n        grid-template-columns: repeat(3, minmax(150px, 1fr));\n    }\n\n    .scl--wpchs-tal-con-str{\n        min-height: 897px;\n    }\n\n    .scl--wtcs-ti-con-st{\n        padding-left: var(--global-laptop-padding-left);\n        padding-right: var(--global-laptop-padding-right);\n    }\n\n    .scl--wpchs-tal-con-str .scl--stv-con-bo-str{\n        height: auto;\n    }\n\n    .scl--wpchs-tal-con-str .scl--scbs-sec-ti-con-bo-str{\n        gap: 20px;\n    }\n\n    .scl--wtcs-nea-fo-lin-dcl-st{\n        gap: 180px;\n    }\n\n    .scl--web-page-ctac-section{\n        min-height: 1393px;\n    }\n\n    .scl--wpcs-cont-stl-bo{\n        padding-left: var(--global-laptop-padding-left);\n        padding-right: var(--global-laptop-padding-right);\n    }\n\n    .scl--wpctas-st-cont-bo-st{\n        grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));\n        gap: 27px;\n    }\n\n    \n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
